export const getFocusedDeckNumber = (state) => state.virtualTrayState.focusedDeckNumber;

export const getAspirateDispenseVolumeModalData = (state) => state.virtualTrayState.aspirateDispenseVolumeModal;

export const getAspirateDispenseVolumeModalCallback = (state) =>
  state.virtualTrayState.aspirateDispenseVolumeModal.onApplyCallback;

export const getAspirateDispenseVolumeModalResult = (state) => {
  const data = getAspirateDispenseVolumeModalData(state);
  const {volume, taskType} = data;

  return {volume, taskType};
};

export const getIsAspirateDispenseModalShown = (state) => state.virtualTrayState.aspirateDispenseVolumeModal.isShown;

export const getDeckLabwareRefs = (state) => state.virtualTrayState.deckLabwareRefs;

export const getVirtualTrayShownModalType = (state) => state.virtualTrayState.shownModal;
